/**
 * Signin Cognito
 */

import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Form, FormGroup } from "reactstrap";
import QueueAnim from "rc-queue-anim";
import {
  Button,
  FormControl,
  Card,
  TextField,
  LinearProgress
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import {
  NotificationManager,
  NotificationContainer
} from "react-notifications";

// app config
import AppConfig from "../../constants/AppConfig";

// redux action
import { createNewUserPassword } from "../../actions";

class StartingNewPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      tempPassword: "",
      password: { value: "", error: false },
      passwordConfirmation: "",
      passwordType: "password"
    };
    this.togglePasswordView = this.togglePasswordView.bind(this);
  }
  componentDidMount() {
    this.setLoadUserCredential();
  }
  setLoadUserCredential() {
    if (this.props.user) {
      this.setState(
        {
          email: this.props.user.email || "",
          tempPassword: this.props.user.tempPassword || ""
        },
        () => {
          if (!this.state.email) {
            this.props.history.push("/signin");
          }
        }
      );
    }
  }
  /**
   * @memberof ResetPasswordStepTwo
   */
  togglePasswordView() {
    let passwordType =
      this.state.passwordType === "password" ? "text" : "password";
    this.setState({ ...this.state, passwordType: passwordType });
  }

  validPassword(password: string): boolean {
    return (
      password.match(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d=+^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`]{8,36}$/
      ) !== null
    );
  }

  /**
   * On User Password creation
   */
  handleNewPassword() {
    if (
      this.state.password.value &&
      !this.state.password.error &&
      this.state.passwordConfirmation === this.state.password.value
    ) {
      this.props.createNewUserPassword(this.state, this.props.history);
    } else {
      if (this.state.password.error || !this.state.password.value) {
        NotificationManager.error("Enter an appropriate password");
      }
      if (
        this.state.passwordConfirmation !== this.state.password.value &&
        !this.state.password.error
      ) {
        NotificationManager.error(
          "Password Confirmed does not match, try again"
        );
      }
      return;
    }
  }

  render() {
    const { password, passwordConfirmation, passwordType } = this.state;
    const { loading } = this.props;
    return (
      <QueueAnim type="bottom" appear={loading}>
        <NotificationContainer />
        <div className="rct-session-wrapper">
          {loading && <LinearProgress />}
          <div className="session-inner-wrapper">
            <div className="container">
              <div
                className="row row-eq-height"
                style={{ justifyContent: "center" }}
              >
                <div className="col-12">
                  <div
                    style={{
                      backgroundColor: "#fa3a12"
                    }}
                    className="session-body text-center mx-auto"
                  >
                    <div className="session-head mb-30">
                      <Link to="/">
                        <img
                          src={AppConfig.appLogo}
                          alt="session-logo"
                          className="img-fluid"
                          width="400"
                          height="102"
                          style={{
                            marginBottom: "25px",
                            width: "400px"
                          }}
                        />
                      </Link>
                      <div className="page-title-wrap">
                        {/* <i className="ti-angle-left" /> */}
                        {this.props.portal ? (
                          this.props.portal === "CUSTOMER" ? (
                            <h2
                              id="page-title"
                              className="text-white page-title"
                            >
                              Customer Portal
                            </h2>
                          ) : this.props.portal === "OPERATIONS" ? (
                            <h2
                              id="page-title"
                              className="text-white page-title"
                            >
                              3PL Portal
                            </h2>
                          ) : (
                            <h2
                              id="page-title"
                              className="text-white page-title"
                            >
                              Tenant Portal
                            </h2>
                          )
                        ) : (
                          <h2 id="page-title" className="text-white page-title">
                            Tenant Portal
                          </h2>
                        )}
                      </div>
                      <p className="mb-0 text-white">
                        We are transforming your freight and logistics
                        experience!
                      </p>
                    </div>
                    <h3 className="text-white">Choose A Password</h3>
                    <Form>
                      <FormGroup>
                        <Card
                          style={{
                            backgroundColor: "#99CCFF",
                            textAlign: "left",
                            paddingTop: "2px"
                          }}
                          className="rounded mb-10"
                        >
                          <span className="has-icon">
                            <i
                              style={{
                                paddingLeft: "10px",
                                fontSize: "10px",
                                color: "red",
                                fontWeight: "bolder"
                              }}
                              className="ti-info"
                            />
                          </span>
                          <span
                            className="fs-12"
                            style={{
                              marginLeft: "5px",
                              color: "black"
                            }}
                          >
                            At least 8 characters, may include lowercase,
                            uppercase, and numbers
                          </span>
                        </Card>
                      </FormGroup>
                      <FormGroup className="has-wrapper col-sm-12 col-md-12 col-xl-12">
                        <FormControl className="has-wrapper">
                          <TextField
                            variant="outlined"
                            label="New Password"
                            value={password.value}
                            type={passwordType}
                            name="user-pwd"
                            id="pwd"
                            style={{
                              backgroundColor: "white",
                              color: "black"
                            }}
                            error={password.error || false}
                            onChange={(inputValue: Object) => {
                              const value = inputValue.target.value;
                              this.setState({
                                password: {
                                  value: value,
                                  error: !this.validPassword(value)
                                }
                              });
                            }}
                          />
                          <span className="has-icon">
                            {passwordType === "text" ? (
                              <Visibility onClick={this.togglePasswordView} />
                            ) : (
                              <VisibilityOff
                                onClick={this.togglePasswordView}
                              />
                            )}
                          </span>
                        </FormControl>
                      </FormGroup>
                      <FormGroup className="has-wrapper col-sm-12 col-md-12 col-xl-12">
                        <FormControl className="has-wrapper">
                          <TextField
                            variant="outlined"
                            value={passwordConfirmation}
                            type={passwordType}
                            label="Password Confirmation"
                            name="user-pwd-conf"
                            id="pwd-conf"
                            style={{
                              backgroundColor: "white",
                              color: "black"
                            }}
                            error={password.value !== passwordConfirmation}
                            onChange={(inputValue: Object) => {
                              this.setState({
                                passwordConfirmation: inputValue.target.value
                              });
                            }}
                          />
                          <span className="has-icon">
                            {passwordType === "text" ? (
                              <Visibility onClick={this.togglePasswordView} />
                            ) : (
                              <VisibilityOff
                                onClick={this.togglePasswordView}
                              />
                            )}
                          </span>
                        </FormControl>
                      </FormGroup>
                      <FormGroup className="mb-15">
                        <Button
                          style={{ backgroundColor: "white" }}
                          className="text--primary w-100"
                          variant="contained"
                          size="large"
                          onClick={() => this.handleNewPassword()}
                        >
                          Next
                        </Button>
                      </FormGroup>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </QueueAnim>
    );
  }
}

// map state to props
const mapStateToProps = ({ authUser }) => {
  const { user, loading } = authUser;
  return { user, loading };
};

export default connect(
  mapStateToProps,
  {
    createNewUserPassword
  }
)(StartingNewPassword);
